import { render } from "./KBPreview.vue?vue&type=template&id=25363b4b&scoped=true"
import script from "./KBPreview.vue?vue&type=script&lang=js"
export * from "./KBPreview.vue?vue&type=script&lang=js"

import "./KBPreview.vue?vue&type=style&index=0&id=25363b4b&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25363b4b"]])

export default __exports__